import React, { useEffect, useState } from "react";
import SessionBookingTable from "../components/session_booking/SessionBookingTable";
import BookingFilters from "../components/session_booking/BookingFilters";
import {
  fetchAllSessionBookings,
  cancelSessionBooking,
  updateSessionZoomLink,
} from "../services/sessionBookingService";

const SessionBookingPage = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ canceled: null });

  const loadBookings = async () => {
    try {
      setLoading(true);

      const res = await fetchAllSessionBookings(filters.canceled);
      setBookings(res.data || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadBookings();
  }, [filters]);

  return (
    <div style={{ padding: "20px" }}>
      <h2>📘 Session Bookings (Admin)</h2>

      <BookingFilters onChange={setFilters} />

      {loading ? (
        <p>Loading bookings...</p>
      ) : (
        <SessionBookingTable
          bookings={bookings}
          onCancel={async (id) => {
            await cancelSessionBooking(id);
            loadBookings();
          }}
          onZoomUpdate={async (id, link) => {
            await updateSessionZoomLink(id, link);
            loadBookings();
          }}
        />
      )}
    </div>
  );
};

export default SessionBookingPage;
